import { LATEST } from "common/sf_strings"
import { WHITE_LABELED_PRODUCT_NAMES } from "config"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import useFeatureFlags from "hooks/useFeatureFlags"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Container, Row, Col } from "reactstrap"

const Footer = (props) => {

  //see here for any type of customizations - https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app
  const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
  const [isFeatureFlagActive] = useFeatureFlags();

  const { current_user, feature_flags_loading } = useSelector((state) => ({
    current_user: state.Login.current_user,
    feature_flags_loading: state.featuresFlags.loading,
  }));

  useEffect(() => {
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/' + INTERCOM_APP_ID;
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();

    const client_user = JSON.parse(localStorage.getItem("authUser"))?.user;
    const admin_user = bsh_getAdminUserDetails();

    if (client_user && admin_user && client_user.token !== admin_user.token) {
      isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_INTERCOM_CHAT_BOX) && AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.INSURANCEAGENTS_AI && !feature_flags_loading && (
        window.Intercom('boot', {
          app_id: INTERCOM_APP_ID,
          email: current_user?.email,
          user_id: current_user?.id,
        })
      )
    }
  }, [current_user?.email, current_user?.id, feature_flags_loading]);


  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {props.showReportingData &&
                <>
                  All data reported in Pacific Standard Time (PST)
                  <br />
                </>
              }
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                © {new Date().getFullYear()} {AppConfiguration.WEBSITE}
                {
                  props?.termsOfServiceVersion &&
                  <>
                    <span className="mx-1">|</span>
                    <a href={`${AppConfiguration.BACKEND_URL}/api/v1/terms_of_services/${props?.termsOfServiceVersion || LATEST}/download`} target="_blank" className="text-sfblue">
                      Terms of Use
                    </a>
                    {
                      isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_REFUND_POLICIES) &&
                      <>
                        <span className="mx-1">|</span>
                        <a href={`${AppConfiguration.BACKEND_URL}/api/v1/refund_policy/${props?.refundPolicies || LATEST}/download`} target="_blank" className="text-sfblue">
                          Refund Policy
                        </a>
                      </>
                    }
                  </>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
